import React from 'react';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" aria-label="Presentación del Kit Adulto de Rescate" style={{
    contain: 'layout'
  }} data-id="element-111">
      {/* Background glow effect - simplified for performance */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-id="element-112">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/8 rounded-full blur-[100px]" data-id="element-113"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-114">
        <div className="flex flex-col items-center" data-id="element-115">
          {/* Text Content - ALL renders immediately, no FadeIn */}
          <div className="flex-1 text-center max-w-3xl" data-id="element-116">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-surface border border-gold/30 text-gold text-sm font-semibold mb-6" data-id="element-117">
              <span className="relative flex h-2 w-2" aria-hidden="true" data-id="element-118">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold opacity-75" data-id="element-119"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-gold" data-id="element-120"></span>
              </span>
              SISTEMA N°1 PARA PADRES EN ARGENTINA
            </div>

            <h1 className="text-5xl md:text-7xl font-bold leading-tight mb-6" data-id="element-121">
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400" data-id="element-122">
                ADULTO DE
              </span>
              <span className="block text-gold drop-shadow-[0_0_15px_rgba(212,168,67,0.3)]" data-id="element-123">
                RESCATE
              </span>
            </h1>

            {/* Hero image - no drop-shadow-2xl, add decoding async */}
            <div className="mb-8" data-id="element-124">
              <img src="https://cdn.magicpatterns.com/uploads/45gAX5xrH7vkndVPg7MKsi/Diseno_sin_titulo_(2).png" alt="Adulto de Rescate — Kit Anti-Crisis para padres de adolescentes" className="mx-auto block max-w-xs md:max-w-md" width={448} height={448} fetchPriority="high" decoding="async" data-id="element-125" />
            </div>

            <p className="text-xl md:text-2xl text-gray-300 font-medium mb-4" data-id="element-126">
              Todo lo que necesitás para acompañar a tu adolescente. Sin buscar.
              Sin improvisar. Sin perder más noches sin dormir.
            </p>
            <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-127">
              Herramientas tácticas para calmar ansiedad, frenar explosiones y
              reconectar con tu hijo.
            </p>

            <div className="flex flex-wrap justify-center gap-4 mb-10" role="list" aria-label="Características principales" data-id="element-128">
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-129">
                <span className="text-2xl" aria-hidden="true" data-id="element-130">
                  🩹
                </span>
                <span className="font-medium text-sm" data-id="element-131">100% Práctico</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-132">
                <Zap className="w-5 h-5 text-yellow" aria-hidden="true" data-id="element-133" />
                <span className="font-medium text-sm" data-id="element-134">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-135">
                <span className="text-2xl" aria-hidden="true" data-id="element-136">
                  👨‍👩‍👧
                </span>
                <span className="font-medium text-sm" data-id="element-137">13 a 18 años</span>
              </div>
              <div className="flex items-center gap-2 bg-surface px-4 py-2 rounded-lg border border-white/5" role="listitem" data-id="element-138">
                <span className="text-2xl" aria-hidden="true" data-id="element-139">
                  🛡️
                </span>
                <span className="font-medium text-sm" data-id="element-140">Todas las crisis</span>
              </div>
            </div>

            <button onClick={() => {
            const target = document.getElementById('elegir-plan');
            if (target) {
              target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }
          }} className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-5 text-lg font-bold text-background bg-gold rounded-xl hover:bg-gold/90 transition-all animate-pulse-glow uppercase tracking-wider cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-141">
              🛡️ → Quiero mi Kit Adulto de Rescate Ahora
            </button>

            <div className="flex flex-wrap justify-center items-center gap-6 mt-6 text-sm text-gray-400" data-id="element-142">
              <div className="flex items-center gap-2" data-id="element-143">
                <ShieldCheck className="w-4 h-4 text-gold" aria-hidden="true" data-id="element-144" />
                <span data-id="element-145">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-146">
                <Lock className="w-4 h-4 text-gold" aria-hidden="true" data-id="element-147" />
                <span data-id="element-148">Pago seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-149">
                <CreditCard className="w-4 h-4 text-gold" aria-hidden="true" data-id="element-150" />
                <span data-id="element-151">Mercado Pago</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}